const shortLinkRegexp = /^((https:\/\/)|(\/\/))?goo\.gl\/maps\//;

const isGoogleMapsShortLink = (value) => shortLinkRegexp.test(value);

export default isGoogleMapsShortLink;
